// src/SearchBar.js
import React, { useEffect, useRef, useState } from "react";
import {
  Image,
  Input,
  List,
  Modal,
  Skeleton,
  Avatar,
  message,
  Typography,
  Col,
  Row,
  Tooltip,
  Select,
} from "antd";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { getSearchbarListAction } from "../../store/action/admin/searchbarActions";
import ShareIcon from "../../Icons/shareIcon";
import { css, keyframes } from "@emotion/css";
import SearchUserIconIcon from "../../Icons/shearchUserIcon";
import DepartmentSearchIcon from "../../Icons/departmentSearchIcon";
import PayrollSearchIcon from "../../Icons/payrollSearchIcon";
import SearchIcon from "../../Icons/SearchIcon";
import UpDownIcon from "../../Icons/UpDownIcon";
import EnterArrowIcon from "../../Icons/EnterArrowIcon";
import KeyControlKIcon from "../../Icons/keyControlKIcon";
import SearchEmptyIcon from "../../Icons/searchEmptyIcon";

import CloseCircleSearchBarIcon from "../../Icons/closeCircleSearchBarIcon";
import FileDocIcon from "../../Icons/FileDocIcon";
import {
  colorCodes,
  textColorCodes,
} from "../../Global/GPTComponents/randomColors";
import MagicIcon from "../../Icons/MagicIcon";
import AIChat from "./AIChat";
import { RecruitmentBackIcon } from "../../Icons/RecruitmentIcons";
import MicIcon from "../../Icons/micIcon";
import annyang from "annyang";
import MicBigIcon from "../../Icons/MicBigIcon";
import MessageTextIcon from "../../Theme/CustomIcons/Icons/Emails,Messages/MessageTextIcon";
import RedoDownRightIcon from "../../Theme/CustomIcons/Icons/Arrow/RedoDownRightIcon";
import { TranslatorDashboardTag } from "../../languageTranslator/LanguageTranslatorTags";

const { Text } = Typography;
const skeletonButton = css`
  /* Add this to your CSS file */
  background: linear-gradient(270deg, #ff7e5f, #feb47b, #7bb4fe, #fe7bb4);
  background-size: 400% 400%;
  animation: gradient-animation 3s ease infinite;
  border: none;
  border-radius: 8px;
  color: transparent;
  // margin-top: 10px;

  @keyframes gradient-animation {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`;

// Add this near your other style definitions at the top
const colorChange = keyframes`
  0% { border-color: #ffbb96; }
  33% { border-color: #96ffbb; }
  66% { border-color: #bb96ff; }
  100% { border-color: #ffbb96; }
`;

// Add these styles to your component
const dashboardInputStyles = css`
  &&& {
    width: 100%;
    height: 40px;
    padding: 8px 12px 8px 8px;
    font-size: 16px;
    background-color: transparent;
    border: 1px solid #ffbb96;
    border-radius: 8px;
    color: white;
    animation: ${colorChange} 6s infinite;

    .ant-input {
      background-color: transparent;
      color: white;
    }

    &::placeholder {
      color: white;
    }

    &:focus {
      outline: none;
      background-color: transparent;
    }

    &:hover {
      background-color: transparent;
    }

    .ant-input-prefix {
      color: #ffbb96;
    }
  }
`;

// Add new state for input focus

// Add these styles near your other style definitions

const SearchBar = ({
  isOnDashboard,
  item,
  setMenuItem,
  onSideBarActive,
  fromDrawer,
  onCancel,
}) => {
  const [isAI, setIsAI] = useState(false);
  const [query, setQuery] = useState("");
  const [hover, setHover] = useState(null);
  const [results, setResults] = useState([]);
  const [focusIndex, setFocusIndex] = useState(-1);
  const [debounceTimeout, setDebounceTimeout] = useState(null);
  const [displayedText, setDisplayedText] = useState("");
  const [isListening, setIsListening] = useState(false);
  const [isInputFocused, setIsInputFocused] = useState(false);

  const scrollRef = useRef(null);
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = (link) => {
    window.location.href = link;
  };
  const searchbarDataList = useSelector((state) => state.searchbarDataList);
  const { searchbarList, searchbarLoading } = searchbarDataList;
  const [openSearch, setOpenSearch] = useState(fromDrawer || false);
  const [modalOpen, setModalOpen] = useState(false);
  const onSearchOpen = () => {
    setOpenSearch(true);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.key === "k") {
        event.preventDefault();
        setOpenSearch((prev) => {
          if (!prev && !fromDrawer) {
            setMenuItem(item?.category);
            onSideBarActive(item?.label1?.toLowerCase());
            // onSearchOpen();
            item.onClick();
          }
          if (prev && fromDrawer) {
            onCancel();
          }
          return !prev;
        });
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    if (openSearch) {
      // dispatch(getSearchbarListAction(""));
      // if (!isOnDashboard && inputRef.current) inputRef.current.focus();
    }
  }, [dispatch, openSearch, isOnDashboard]);

  const handleButtonChange = async (notes) => {
    if (notes) {
      const value = notes;
      setQuery(value);
      await dispatch(getSearchbarListAction(value));
    }
  };

  const handleInputChange = async (value) => {
    const lowercaseValue = value?.toLowerCase() || ""; // Ensure value is a string
    setQuery(lowercaseValue);

    // Clear the previous timeout if it exists
    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }

    // Set a new timeout to delay the dispatch
    const newDebounceTimeout = setTimeout(async () => {
      await dispatch(getSearchbarListAction(lowercaseValue));
    }, 800); // Adjust debounce delay as needed

    setDebounceTimeout(newDebounceTimeout);
  };

  useEffect(() => {
    if (query && query.length > 0) {
      if (searchbarDataList.searchbarList) {
        const queryWords = query.toLowerCase().split(/\s+/);
        const regex = new RegExp(queryWords.join("|"), "gi");
        let filteredResults = [];
        if (
          searchbarDataList.searchbarList?.newUsers &&
          searchbarDataList.searchbarList?.newUsers.length > 0 &&
          searchbarDataList.searchbarList?.searchbar &&
          searchbarDataList.searchbarList?.searchbar.length > 0
        ) {
          const searchbarResults =
            searchbarDataList.searchbarList.searchbar?.map((item) => {
              const originalText = item.title;
              const highlightedText = originalText.replace(
                regex,
                (match) => `<span class="highlight">${match}</span>`
              );
              return { ...item, highlightedText };
            });

          const newUsersResults = searchbarDataList.searchbarList.newUsers?.map(
            (item) => {
              const fields = ["empId", "name.firstName", "name.lastName"];
              let highlightedText = "";

              fields.forEach((field) => {
                const fieldParts = field.split(".");
                let originalText = item;

                fieldParts.forEach((part) => {
                  if (originalText && originalText[part]) {
                    originalText = originalText[part];
                  } else {
                    originalText = null;
                  }
                });

                if (originalText) {
                  highlightedText +=
                    originalText.replace(
                      regex,
                      (match) => `<span class="highlight">${match}</span>`
                    ) + " ";
                }
              });

              return { ...item, highlightedText: highlightedText.trim() };
            }
          );

          filteredResults = [...searchbarResults, ...newUsersResults];
        } else if (
          searchbarDataList.searchbarList?.searchbar &&
          searchbarDataList.searchbarList?.searchbar.length > 0
        ) {
          filteredResults = searchbarDataList.searchbarList.searchbar?.map(
            (item) => {
              const originalText = item.title;
              const highlightedText = originalText.replace(
                regex,
                (match) => `<span class="highlight">${match}</span>`
              );
              return { ...item, highlightedText };
            }
          );
        } else if (
          searchbarDataList.searchbarList?.newUsers &&
          searchbarDataList.searchbarList?.newUsers.length > 0
        ) {
          filteredResults = searchbarDataList.searchbarList.newUsers?.map(
            (item) => {
              const fields = ["empId", "name.firstName", "name.lastName"];
              let highlightedText = "";

              fields.forEach((field) => {
                const fieldParts = field.split(".");
                let originalText = item;

                // Traverse nested object
                fieldParts.forEach((part) => {
                  if (originalText && originalText[part]) {
                    originalText = originalText[part];
                  } else {
                    originalText = null;
                  }
                });
                if (originalText) {
                  highlightedText +=
                    originalText.replace(
                      regex,
                      (match) => `<span class="highlight">${match}</span>`
                    ) + " ";
                }
              });
              const title = `${item?.empId} - ${item?.name?.firstName} ${item?.name?.lastName}`;
              return {
                ...item,
                title,
                highlightedText: highlightedText.trim(),
              };
            }
          );
        }
        setResults(filteredResults);
        // Reset focusIndex when input value changes
        setFocusIndex(-1);
      } else {
        setResults([]);
      }
    } else {
      let filteredResults =
        searchbarDataList.searchbarList?.searchbar &&
        searchbarDataList.searchbarList?.searchbar.length > 0 &&
        searchbarDataList.searchbarList?.searchbar?.map((item) => {
          const highlightedText = item?.title;
          return { ...item, highlightedText };
        });

      setResults(filteredResults);
    }
  }, [searchbarDataList, query, searchbarLoading]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (!searchbarLoading) {
        if (fromDrawer) {
          if (!isAI) {
            // if (!openSearch || !results || results.length === 0) return;
            const scrollContainer = scrollRef.current;

            if (event.key === "ArrowDown") {
              setFocusIndex((prevIndex) => {
                const newIndex = (prevIndex + 1) % results.length;
                setQuery(results[newIndex]?.title || "");
                setHover(results[newIndex]?._id);
                const item = scrollContainer.children[newIndex];
                const itemTop = item.offsetTop;
                const itemBottom = itemTop + item.clientHeight;
                if (newIndex === 0) {
                  scrollContainer.scrollTop = 0; // Scroll to top when wrapping around
                } else if (
                  itemBottom >
                  scrollContainer.scrollTop + scrollContainer.clientHeight
                ) {
                  scrollContainer.scrollTop =
                    itemBottom - scrollContainer.clientHeight;
                }
                return newIndex;
              });
            } else if (event.key === "ArrowUp") {
              setFocusIndex((prevIndex) => {
                const newIndex =
                  (prevIndex - 1 + results.length) % results.length;
                setQuery(results[newIndex]?.title || "");
                setHover(results[newIndex]?._id);
                const item = scrollContainer.children[newIndex];
                const itemTop = item.offsetTop;

                if (newIndex === results.length - 1) {
                  scrollContainer.scrollTop = scrollContainer?.scrollHeight; // Scroll to bottom when wrapping around
                } else if (
                  itemTop <
                  scrollContainer.scrollTop + scrollContainer?.clientHeight
                ) {
                  scrollContainer.scrollTop =
                    itemTop - scrollContainer.clientHeight;
                }
                return newIndex;
              });
            } else if (event.key === "Enter") {
              const link = results[focusIndex]?.link
                ? `${process.env.REACT_APP_FE_HR_URL}${
                    results[focusIndex].link
                  }${
                    results[focusIndex]?.action
                      ? `?action=${results[focusIndex].action}`
                      : ""
                  }`
                : "";
              const Id = results[focusIndex]?._id
                ? results[focusIndex]?._id
                : null;
              if (link) {
                navigate(link);

                setOpenSearch(false);
              } else if (Id) {
                onChange(Id);
                setOpenSearch(false);
              }
            } else if (
              (event.ctlKey || event.metaKey || event.key === "Meta") &&
              event.key === "k"
            ) {
              // Check for Meta key and "k" separately
              event.preventDefault();
              setOpenSearch((prev) => !prev);
            }
          }
        }
      }
    };
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [
    openSearch,
    results,
    focusIndex,
    setQuery,
    setOpenSearch,
    setHover,
    navigate,
  ]);

  const handleOk = () => {
    if (audioRef && audioRef.current) {
      audioRef.current.pause();
    }
    setIsListening(false);
    setQuery("");
    setOpenSearch(false);
  };
  const handleModalOpen = () => {
    setModalOpen(true);
  };
  const handleModalClose = () => {
    setModalOpen(false);
  };
  const sharedLogin = useSelector((state) => state.sharedLogin);
  const { sharedUserInfo } = sharedLogin;
  let userType = "";
  if (sharedUserInfo?.payload) {
    userType = sharedUserInfo?.payload?.type;
  } else {
    userType = sharedUserInfo?.type;
  }
  const roleFeatures = sharedUserInfo.userAccess;

  const onChange = async (Id) => {
    if (
      userType === "admin" ||
      (userType !== "user" && roleFeatures?.includes("65"))
    ) {
      try {
        localStorage.setItem("UserInfo", JSON.stringify(Id, null, " "));
        let id = null;
        if (Id) {
          id = Id.slice(-5);
        }
        setOpenSearch(false);
        userType === "admin"
          ? navigate(
              process.env.REACT_APP_FE_HR_URL +
                `/admin/company/employees/?action=${id}`
            )
          : userType !== "user"
          ? navigate(
              process.env.REACT_APP_FE_HR_URL +
                `/manager/company/employees/?action=${id}`
            )
          : navigate(process.env.REACT_APP_FE_HR_URL + `/login`);
      } catch (error) {
        message.error("There is some internet issue!");
      }
    }
  };

  const modalStyle = css`
    .ant-modal-body {
      padding: 0px !important;
      ${isAI && "max-height:80vh; overflow:auto;height:80vh;"}
    }
    ${isAI &&
    `.ant-modal-header{
      padding-inline:12px;
    }`}
    .ant-modal-close {
      display: none !important;
    }
    @keyframes gradient-animation1 {
      0% {
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
          0 6px 20px 0 rgba(0, 0, 0, 0.19), 0 0 10px 5px rgba(255, 126, 95);
      }
      50% {
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
          0 6px 20px 0 rgba(0, 0, 0, 0.19), 0 0 10px 5px rgba(123, 180, 254);
      }
      100% {
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
          0 6px 20px 0 rgba(0, 0, 0, 0.19), 0 0 10px 5px rgba(255, 126, 95);
      }
    }
    .ant-modal-content {
      animation: gradient-animation1 3s infinite;
    }
  `;

  const [note, setNote] = useState(null);
  const [audioContext, setAudioContext] = useState(null);
  const [mediaStream, setMediaStream] = useState(null);
  const [analyser, setAnalyser] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  const canvasRef = useRef(null);
  const audioRef = useRef(null);
  const micRef = useRef(null);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (window.SpeechRecognition || window.webkitSpeechRecognition) {
      const SpeechRecognition =
        window.SpeechRecognition || window.webkitSpeechRecognition;
      const mic = new SpeechRecognition();
      mic.continuous = true;
      mic.interimResults = true;
      mic.lang = "en-US";
      micRef.current = mic;
    } else {
      message.error("Browser does not support Speech Recognition");
    }

    return () => {
      if (micRef.current) {
        micRef.current.stop();
      }
    };
  }, []);

  useEffect(() => {
    handleListen();

    // Stop mic when component unmounts
  }, [isListening]); // Include mic as a dependency

  useEffect(() => {
    if (audioContext && analyser) {
      visualizeAudio();
    }
  }, [audioContext, analyser]);

  const handleListen = async () => {
    let silenceTimer;
    const mic = micRef.current;
    if (mic) {
      if (isListening) {
        speak();
        // mic.onend = () => {
        //   mic.start();
        // };
        if (debounceTimeout) {
          clearTimeout(debounceTimeout);
        }

        // Set a new timeout to delay the dispatch
        const newDebounceTimeout = setTimeout(async () => {
          mic.start();

          silenceTimer = setTimeout(() => {
            stopAudioContext(); // Stop any audio context if needed
            mic.stop();
            setIsListening(false); // Update listening state if needed
          }, 8000);
        }, 3100); // Adjust the debounce delay as needed (500ms here)

        setDebounceTimeout(newDebounceTimeout);

        startAudioContext();
      } else {
        await stopAudioContext();
        mic.stop();
        mic.onend = () => {};
      }
      // mic.onstart = () => {
      // };
      // Reset the timer on every result
      mic.onresult = (event) => {
        clearTimeout(silenceTimer); // Clear the silence timer on every result

        const transcript = Array.from(event.results)
          ?.map((result) => result[0])
          ?.map((result) => result.transcript)
          .join("");

        setQuery(transcript);

        // Set a new silence timer to stop microphone after 800ms of silence
        silenceTimer = setTimeout(() => {
          stopAudioContext(); // Stop any audio context if needed
          mic.stop();
          handleButtonChange(transcript); // Handle changes after stopping mic due to silence
          setIsListening(false);
        }, 1000); // Adjust this timeout as needed

        // Clear any existing mic.onerror handler and set a new one
        mic.onerror = (event) => {
          console.error("Microphone error:", event.error);
        };
      };
    }
  };

  const startAudioContext = async () => {
    if (!audioContext) {
      const newAudioContext = new (window.AudioContext ||
        window.webkitAudioContext)();
      setAudioContext(newAudioContext);

      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      setMediaStream(stream);

      const source = newAudioContext.createMediaStreamSource(stream);
      const newAnalyser = newAudioContext.createAnalyser();

      source.connect(newAnalyser);
      setAnalyser(newAnalyser);
    }
  };

  const stopAudioContext = async () => {
    if (audioContext) {
      // Stop all tracks in the media stream
      if (mediaStream) {
        mediaStream.getTracks().forEach((track) => track.stop());
        setMediaStream(null);
      }

      try {
        setAudioContext(null);
        setAnalyser(null);
      } catch (error) {
        console.error("Error closing AudioContext:", error);
      }
    }
  };

  const visualizeAudio = () => {
    const canvas = canvasRef.current;
    if (canvas) {
      const canvasCtx = canvas.getContext("2d");
      analyser.fftSize = 2048;
      const bufferLength = analyser.fftSize;
      const dataArray = new Uint8Array(bufferLength);

      const draw = () => {
        if (!audioContext) {
          return;
        }

        requestAnimationFrame(draw);

        analyser.getByteTimeDomainData(dataArray);

        canvasCtx.clearRect(0, 0, canvas.width, canvas.height);
        canvasCtx.fillStyle = "transparent";
        canvasCtx.fillRect(0, 0, canvas.width, canvas.height);

        const gradient = canvasCtx.createLinearGradient(0, 0, canvas.width, 0);
        gradient.addColorStop(0, "#ff7e5f");
        gradient.addColorStop(0.5, "#feb47b");
        gradient.addColorStop(1, "#7bb4fe");

        canvasCtx.lineWidth = 4;
        canvasCtx.strokeStyle = gradient ? gradient : "rgb(242, 239, 239)";

        const centerX = canvas.width / 2;
        const centerY = canvas.height / 2;
        const radius = Math.min(centerX, centerY) - 70;

        for (let i = 0; i < bufferLength; i++) {
          const angle = (i / bufferLength) * 2 * Math.PI;
          const v = dataArray[i] / 118.0;
          const length = radius + v * 10;
          const x = centerX + length * Math.cos(angle);
          const y = centerY + length * Math.sin(angle);

          if (i === 0) {
            canvasCtx.beginPath();
            canvasCtx.moveTo(x, y);
          } else {
            canvasCtx.lineTo(x, y);
          }
        }

        canvasCtx.closePath();
        canvasCtx.stroke();
      };

      draw();
    }
  };

  const speak = () => {
    // if ("speechSynthesis" in window) {
    //   const voices = speechSynthesis.getVoices();

    //   // Choose a specific voice (example: 'Google UK English Female')
    //   const selectedVoice = voices.find(
    //     (voice) => voice.name === "Google UK English Female"
    //   );

    //   const utterance = new SpeechSynthesisUtterance(
    //     "Hi I am Max, How may I help you"
    //   );
    const fullText = "Hello I am Max How Can I Help You";
    //   // Set the selected voice
    //   if (selectedVoice) {
    //     utterance.voice = selectedVoice;
    //   } else {
    //   }

    //   speechSynthesis.speak(utterance);
    // } else {
    // }
    audioRef.current.play();

    const words = fullText.split(" ");
    let index = 0;

    intervalRef.current = setInterval(() => {
      if (fromDrawer) {
        if (index < words.length) {
          setDisplayedText((prev) => words[index]);
          index += 1;
        } else {
          setDisplayedText("Max Listening..");
          clearInterval(intervalRef.current);
        }
      }
    }, 400);
  };
  useEffect(() => {
    return () => {
      // Clear the interval if the component is unmounted
      if (intervalRef.current) {
        setDisplayedText("");
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  const placeholders = [
    "Search anything or Ask Max…",
    "What do you want to know today?",
    "Type your query here…",
    "Ask me anything...",
    "Looking for something specific?",
  ];

  const [placeholderIndex, setPlaceholderIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (fromDrawer) {
        setPlaceholderIndex(
          (prevIndex) => (prevIndex + 1) % placeholders.length
        );
      }
    }, 3002); // Change placeholder every 30 seconds

    // Cleanup interval on component unmount
    return () => clearInterval(intervalId);
  }, [placeholders.length]);

  // const handleSaveNote = () => {
  //   setSavedNotes([...savedNotes, note]);
  //   setNote("");
  // };
  const themeDefault = useSelector((state) => state.themeDefault);
  const rainbowAnimation = keyframes`
    // 0% { border-color: red; }
    // 16.67% { border-color: orange; }
    // 33.33% { border-color: yellow; }
    // 50% { border-color: green; }
    // 66.67% { border-color: blue; }
    // 83.33% { border-color: indigo; }
    // 100% { border-color: violet; }
    0%{border-color: hsl(0deg 86.07% 60.59% / 1); color:hsl(0deg 86.07% 60.59% / 1)}
    50%{border-color: hsl(180deg 86.07% 60.59% / 1); color:hsl(180deg 86.07% 60.59% / 1)}
    100%{border-color: hsl(360deg 86.07% 60.59% / 1); color:hsl(360deg 86.07% 60.59% / 1)}
  `;

  const dropdownStyles = css`
    color: ${themeDefault?.info?.newConfig?.color};
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: ${themeDefault?.info?.newConfig
      ?.PopoverBackgroundAccentSolidColor}08;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    margin-top: 4px;
    z-index: 1000;
    max-height: 400px;
    overflow-y: auto;
    backdrop-filter: blur(100px);
  `;

  const sidebarItemStyles = (isActive) => css`
    color: ${isActive
      ? themeDefault?.info?.newConfig?.colorSecondary
      : themeDefault?.info?.newConfig?.color};
    // background: ${isActive
      ? themeDefault?.info?.colorPrimary
      : "transparent"};
    overflow: hidden;
    // border: 1px solid
    // ${isActive
      ? themeDefault?.info?.colorPrimary
      : themeDefault?.info?.themeColor === "purple"
      ? "white"
      : themeDefault?.info?.themeColor === "dark"
      ? "rgba(255, 255, 255, 0.14)"
      : themeDefault?.info?.themeColor === "default"
      ? "#e0dcd9"
      : "#e0dcd9"};

    border: 1px solid;
    animation: ${rainbowAnimation} 5s linear infinite;
    .anticon {
      animation: ${rainbowAnimation} 5s linear infinite;
      border: 0 !important;
    }
    // box-shadow: ${isActive
      ? "0px 4px 10px 0px rgba(0, 0, 0, 0.08)"
      : "none"};
    cursor: pointer;
    border-radius: ${themeDefault?.info?.borderRadius}px;
    display: flex;
    flex-direction: row;
    align-items: center;
    transition: background 0.3s ease-in-out, border 0.3s ease-in-out,
      height 0.3s ease-in-out, width 0.2s, transform 0.3s ease-in-out;

    // gap: clamp(2px, 0.4vw, 6px);
    height: clamp(25px, 2.5vw, 40px);
    width: ${isActive ? "clamp(80px, 9vw, 135px)" : "clamp(50px, 4.6vw, 70px)"};

    justify-content: center;
    .sidebarIcon {
      color: ${isActive
        ? themeDefault?.info?.newConfig?.colorSecondary
        : themeDefault?.info?.newConfig?.color};
      transition: transform 0.3s ease-in-out;
      display: flex;
    }

    .sidebarMenuText {
      display: ${isActive ? "block" : "none"};

      color: ${themeDefault?.info?.newConfig?.color};
      font-size: clamp(8px, 0.96vw, 14px);
    }

    &:hover {
      color: red;
      border: 1px solid ${themeDefault?.info?.colorPrimary};

      .sidebarIcon {
        color: ${isActive
          ? themeDefault?.info?.newConfig?.color
          : themeDefault?.info?.newConfig?.color};
      }

      .sidebarMenuText {
        color: ${isActive
          ? themeDefault?.info?.newConfig?.color
          : themeDefault?.info?.newConfig?.color};
        display: block;
      }

      width: clamp(80px, 9vw, 135px);
    }
  `;

  let modules = [];
  if (sharedUserInfo?.payload?.company) {
    modules = sharedUserInfo?.payload?.company?.modules;
  } else {
    modules =
      sharedUserInfo?.empCompanies && sharedUserInfo?.empCompanies.length > 0
        ? sharedUserInfo?.empCompanies[0]?.companyId?.modules
        : [];
  }

  return !fromDrawer ? (
    <div
      style={{ display: "flex" }}
      className={sidebarItemStyles(true)}
      onClick={(e) => {
        setMenuItem(item?.category);
        onSideBarActive(item?.label1?.toLowerCase());
        // onSearchOpen();
        item.onClick(e);
        setOpenSearch(true);
      }}
    >
      <div className="sidebarIcon">{item?.icon}</div>
      <Text className="sidebarMenuText">{item?.label}</Text>
    </div>
  ) : (
    <>
      {" "}
      <Modal
        footer={null}
        open={modalOpen}
        className={modalStyle + " " + "maxai"}
        onOk={handleModalOpen}
        onCancel={handleModalClose}
        centered={isAI}
        id="maxai"
        style={{ zIndex: "1000000000" }}
        title={
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <RecruitmentBackIcon
              onClick={() => {
                handleModalClose();
              }}
            />{" "}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                // gap: "2px",
              }}
            >
              <MagicIcon />
              <span
                style={{
                  fontWeight: 600,
                }}
              >
                <TranslatorDashboardTag>Max AI</TranslatorDashboardTag>
              </span>
            </div>
          </div>
        }
        width={
          isAI
            ? "80%"
            : focusIndex !== -1 && results && results.length > 0
            ? 950
            : 550
        }
      >
        <AIChat />
      </Modal>
      <div
        className={css`
          max-width: ${isOnDashboard ? "600px" : "908px"};
          width: 100%;
          padding: 0px 40px;
        `}
        style={{
          display:
            focusIndex !== -1 && results && results.length > 0
              ? "flex"
              : "block",
        }}
      >
        <div
          className={
            focusIndex !== -1 &&
            results &&
            results?.length > 0 &&
            query &&
            css`
              width: 70%;
            `
          }
        >
          <audio
            ref={audioRef}
            src="/MaxStartVoice.mp3" // Correct way to reference a file in the public directory
          />
          {/* <div> */}
          <div style={{ position: "relative", width: "100%" }}>
            <Select
              showSearch
              allowClear
              style={{ width: "100%" }}
              value={query}
              onChange={(value) => setQuery(value)}
              onSearch={handleInputChange}
              filterOption={false}
              placeholder={placeholders[placeholderIndex]}
              suffixIcon={
                <div
                  className={css`
                    font-size: clamp(8px, 1.2vw, 14px) !important;
                    height: 100%;
                    display: flex;
                    align-items: center;
                  `}
                >
                  {!isOnDashboard && (
                    <MicIcon
                      onClick={() => {
                        setIsListening((prevState) => !prevState);
                        if (isListening) {
                          handleButtonChange(query);
                        }
                        setNote("");
                      }}
                    />
                  )}
                  <SearchIcon />
                </div>
              }
              options={
                searchbarLoading
                  ? []
                  : Array.isArray(results)
                  ? [
                      ...(!searchbarLoading && !query
                        ? [
                            {
                              isHeading: true,
                              disabled: true,
                              label: (
                                <div style={{ padding: "16px 15px" }}>
                                  <p
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "12px",
                                    }}
                                  >
                                    FREQUENT ACTIONS
                                  </p>
                                </div>
                              ),
                            },
                          ]
                        : []),
                      ...(!searchbarLoading &&
                      query &&
                      results &&
                      results.length > 0
                        ? [
                            {
                              isHeading: true,
                              disabled: true,
                              label: (
                                <div style={{ padding: "16px 15px" }}>
                                  <p
                                    style={{
                                      fontWeight: "bold",
                                      fontSize: "12px",
                                    }}
                                  >
                                    BEST MATCH
                                  </p>
                                </div>
                              ),
                            },
                          ]
                        : []),
                      ...results.map((item, index) => ({
                        label: (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              padding: "8px 0",
                            }}
                          >
                            {item?.link ? (
                              <>
                                {item?.link === "/admin/employees" ? (
                                  <SearchUserIconIcon />
                                ) : item?.link === "/admin/teams" ? (
                                  <DepartmentSearchIcon />
                                ) : item?.link === "/admin/payroll" ? (
                                  <PayrollSearchIcon />
                                ) : item?.link.includes("report") ? (
                                  <FileDocIcon />
                                ) : null}
                                <div style={{ marginLeft: 10 }}>
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: item?.highlightedText,
                                    }}
                                  />
                                  <div
                                    style={{
                                      color: "#9A8EA4",
                                      fontSize: "12px",
                                    }}
                                  >
                                    {item?.linkDescription}
                                  </div>
                                </div>
                              </>
                            ) : (
                              <Col span={24}>
                                <div
                                  onClick={() => onChange(item?._id)}
                                  onMouseEnter={() => setHover(item?._id)}
                                  onMouseLeave={() => setHover(null)}
                                  key={item?._id}
                                  className={css`
                                    display: flex;
                                    justify-content: space-between;
                                    align-items: center;
                                    padding: 10px;
                                    background-color: ${focusIndex === index
                                      ? themeDefault?.info?.newConfig
                                          ?.backgroundColorSecondary
                                      : "transparent"};
                                    border-radius: ${focusIndex === index
                                      ? "8px"
                                      : "0"};
                                    &:hover {
                                      background-color: ${themeDefault?.info
                                        ?.newConfig?.backgroundColorSecondary};
                                      border-radius: 8px;
                                    }
                                  `}
                                >
                                  <div style={{ display: "flex" }}>
                                    <Avatar
                                      size={48}
                                      style={{
                                        fontSize: 16,
                                        background:
                                          colorCodes[index % colorCodes.length],
                                      }}
                                      icon={
                                        item?.profileImage?.url === "dummy" ? (
                                          <span
                                            style={{
                                              textTransform: "uppercase",
                                              color:
                                                textColorCodes[
                                                  index % textColorCodes.length
                                                ],
                                            }}
                                          >
                                            {item?.name?.firstName[0] +
                                              item?.name?.lastName[0]}
                                          </span>
                                        ) : (
                                          <img
                                            alt=""
                                            src={item?.profileImage?.url}
                                          />
                                        )
                                      }
                                    />
                                    <div
                                      style={{
                                        marginLeft: "10px",
                                        display: "flex",
                                        gap: "8px",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <span
                                        className={css`
                                          color: ${themeDefault?.info?.newConfig
                                            ?.color};
                                        `}
                                        dangerouslySetInnerHTML={{
                                          __html: item?.highlightedText,
                                        }}
                                      />
                                      <span style={{ color: "#9A8EA4" }}>
                                        <TranslatorDashboardTag>
                                          Dashboard / User Profile
                                        </TranslatorDashboardTag>
                                      </span>
                                    </div>
                                  </div>
                                  {hover === item?._id && (
                                    <ShareIcon style={{ fontSize: "24px" }} />
                                  )}
                                </div>
                              </Col>
                            )}
                          </div>
                        ),
                        value:
                          item?.title ||
                          `${item?.empId} - ${item?.name?.firstName} ${item?.name?.lastName}`,
                        key: item?._id,
                      })),
                    ]
                  : []
              }
              notFoundContent={
                searchbarLoading ? (
                  <div
                    style={{
                      padding: "10px 0px",
                      paddingTop: "0px",
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    <Skeleton.Button
                      style={{ width: "100%", height: "50px" }}
                      className={skeletonButton}
                    />
                    <Skeleton.Button
                      style={{ width: "100%", height: "50px" }}
                      className={skeletonButton}
                    />
                  </div>
                ) : results?.length === 0 ? (
                  <Col
                    span={24}
                    className={css`
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      height: 270px;
                    `}
                  >
                    <div
                      className={css`
                        width: 80%;
                        text-align: center;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                      `}
                    >
                      <SearchEmptyIcon />
                      <span>
                        <Text>
                          <TranslatorDashboardTag>
                            Well, this is awkward.
                          </TranslatorDashboardTag>
                        </Text>
                      </span>
                      <p style={{ color: "#9A8EA4", fontSize: "14px" }}>
                        <TranslatorDashboardTag>
                          Nothing is turning up with that word or phrase. Please
                          try entering another, or check out our help topics.
                        </TranslatorDashboardTag>
                      </p>
                    </div>
                  </Col>
                ) : (
                  "No results found"
                )
              }
              className={isOnDashboard ? dashboardInputStyles : ""}
              dropdownStyle={{
                background:
                  themeDefault?.info?.newConfig
                    ?.PopoverBackgroundAccentSolidColor + "08",
                backdropFilter: "blur(100px)",
                padding: "8px",
                borderRadius: "8px",
                maxHeight: "400px",
              }}
              onSelect={(value, option) => {
                const selectedItem = results.find(
                  (item) => item._id === option.key
                );
                if (selectedItem?.link) {
                  const link = `${process.env.REACT_APP_FE_HR_URL}${
                    selectedItem.link
                  }${
                    selectedItem?.action ? `?action=${selectedItem.action}` : ""
                  }`;
                  navigate(link);
                  setOpenSearch(false);
                } else if (selectedItem?._id) {
                  onChange(selectedItem._id);
                  setOpenSearch(false);
                }
              }}
            />

            {/* Dropdown content */}
            {isOnDashboard && isInputFocused && (
              <div className={`search-dropdown ${dropdownStyles}`}>
                {/* Existing content below input */}
                <div style={{ padding: "16px" }}>
                  {/* Your existing content structure */}
                  {searchbarLoading ? (
                    <div
                      style={{
                        padding: "10px 0px",
                        paddingTop: " 0px",
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                      }}
                    >
                      <Skeleton.Button
                        style={{
                          width: "530px",
                          height: "50px",
                          width: "100%",
                        }}
                        className={skeletonButton}
                      />
                      <Skeleton.Button
                        style={{
                          width: "530px",
                          height: "50px",
                          width: "100%",
                        }}
                        className={skeletonButton}
                      />
                    </div>
                  ) : (
                    <>
                      {searchbarDataList.searchbarList?.searchbar &&
                        searchbarDataList.searchbarList?.searchbar?.length >
                          0 &&
                        query &&
                        query?.length > 0 && (
                          <div style={{ padding: "16px 15px " }}>
                            <Text
                              style={{ fontWeight: "bold", fontSize: "12px" }}
                            >
                              <TranslatorDashboardTag>
                                BEST MATCH{" "}
                              </TranslatorDashboardTag>
                            </Text>
                          </div>
                        )}

                      <Row
                        gutter={[8, 8]}
                        style={{
                          overflow: "auto",
                          maxHeight: "400px",
                          overflowX: "hidden",
                        }}
                      >
                        <Col span={24}>
                          <Row gutter={[8, 8]} ref={scrollRef}>
                            {query &&
                              results &&
                              results?.length > 0 &&
                              results?.map((item, index) => {
                                if (item?.link) {
                                  const link = item?.link
                                    ? `${process.env.REACT_APP_FE_HR_URL}${
                                        item.link
                                      }${
                                        item?.action
                                          ? `?action=${item.action}`
                                          : ""
                                      }`
                                    : "";

                                  const isFocused = focusIndex === index;

                                  return (
                                    <Col span={24}>
                                      <div
                                        // href={link}
                                        onClick={() => {
                                          navigate(link);
                                        }}
                                        onMouseEnter={() => setHover(item?._id)}
                                        onMouseLeave={() => setHover(null)}
                                        key={item?._id}
                                        className={css`
                                          cursor: pointer;
                                          display: flex;
                                          justify-content: space-between;
                                          padding: 10px 10px;
                                          align-items: center;
                                          transition: background-color 0.3s
                                            ease-in-out;
                                          background-color: ${isFocused
                                            ? themeDefault?.info?.newConfig
                                                ?.backgroundColorSecondary
                                            : "transparent"};
                                          border-radius: ${isFocused
                                            ? "8px"
                                            : "0"};
                                          &:hover {
                                            background-color: ${themeDefault
                                              ?.info?.newConfig
                                              ?.backgroundColorSecondary};
                                            border-radius: 8px;
                                            // span {
                                            //   color: red !important;
                                            // }
                                          }
                                        `}
                                      >
                                        <div style={{ display: "flex" }}>
                                          {item?.link === "/admin/employees" ? (
                                            <SearchUserIconIcon />
                                          ) : item?.link === "/admin/teams" ? (
                                            <DepartmentSearchIcon />
                                          ) : item?.link ===
                                            "/admin/payroll" ? (
                                            <PayrollSearchIcon />
                                          ) : item?.link.includes("report") ? (
                                            <FileDocIcon />
                                          ) : (
                                            <></>
                                          )}
                                          <div
                                            className={css`
                                              margin-left: 10px;
                                              display: flex;
                                              gap: 4px;
                                              flex-direction: column;
                                              // height: 20px;
                                              justify-content: space-between;
                                            `}
                                          >
                                            <span
                                              className={css`
                                                color: ${themeDefault?.info
                                                  ?.newConfig?.color};
                                              `}
                                              dangerouslySetInnerHTML={{
                                                __html: item?.highlightedText,
                                              }}
                                            />
                                            {/* <br /> */}
                                            <span style={{ color: "#9A8EA4" }}>
                                              {item?.linkDescription}
                                            </span>
                                          </div>
                                        </div>
                                        {hover === item?._id && (
                                          <span>
                                            <RedoDownRightIcon
                                              size={"large"}
                                              style={{
                                                height: "0px",
                                              }}
                                            />
                                          </span>
                                        )}
                                      </div>
                                    </Col>
                                  );
                                }
                              })}
                          </Row>
                        </Col>

                        {results && results?.length === 0 && (
                          <Col
                            span={24}
                            className={css`
                              display: flex;
                              justify-content: center;
                              align-items: center;
                              height: 270px;
                            `}
                          >
                            <div
                              className={css`
                                width: 80%;
                                text-align: center;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                              `}
                            >
                              <SearchEmptyIcon />
                              <span>
                                <Text>
                                  <TranslatorDashboardTag>
                                    Well, this is awkward.
                                  </TranslatorDashboardTag>
                                </Text>
                              </span>
                              <p style={{ color: "#9A8EA4", fontSize: "14px" }}>
                                <TranslatorDashboardTag>
                                  Nothing is turning up with that word or
                                  phrase. Please try entering another, or check
                                  out our help topics.
                                </TranslatorDashboardTag>
                              </p>
                            </div>
                          </Col>
                        )}
                      </Row>
                      <style>
                        {`
                    .highlight {
                     color: #F16444;
                     font-weight: bold;
                     text-decoration:underline;
                    }
                  `}
                      </style>
                    </>
                  )}
                  {query && results && results?.length > 0 && (
                    <div
                      className={css`
                        align-items: center;
                        border-top: 1px solid #33160024;
                        display: flex;
                        justify-content: space-between;
                      `}
                    >
                      <div
                        className={css`
                          display: flex;
                          padding: 8px 10px;
                        `}
                      >
                        <div
                          className={css`
                            display: flex;
                            margin-left: 10px;
                            gap: 10px;
                          `}
                        >
                          <UpDownIcon style={{ marginTop: "5px" }} />
                          <p
                            style={{
                              marginLeft: "5px",
                              color: "#9A8EA4",
                              fontSize: "14px",
                              lineHeight: "30px",
                            }}
                          >
                            <TranslatorDashboardTag>
                              Navigate
                            </TranslatorDashboardTag>
                          </p>
                        </div>
                        <div
                          className={css`
                            display: flex;
                            margin-left: 15px;
                          `}
                        >
                          <EnterArrowIcon style={{ marginTop: "5px" }} />
                          <p
                            style={{
                              marginLeft: "5px",
                              color: "#9A8EA4",
                              fontSize: "14px",
                              lineHeight: "30px",
                            }}
                          >
                            <TranslatorDashboardTag>
                              Open
                            </TranslatorDashboardTag>
                          </p>
                        </div>
                      </div>
                      <div
                        className={css`
                          padding: 8px 10px;
                        `}
                      >
                        <KeyControlKIcon />
                      </div>
                    </div>
                  )}{" "}
                </div>
              </div>
            )}
          </div>
          {/* {query && focusIndex === -1 ? (
              <span style={{ color: "grey" }}> - Open</span>
            ) : (
              <span style={{ color: "grey" }}>No results</span>
            )}
          </div> */}
          {/* For Mic */}
          {isListening ? (
            <>
              {" "}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <canvas ref={canvasRef} width="550" height="220"></canvas>
                <div
                  className={css`
                    border-radius: 50px; /* Adjust as needed */
                    margin-top: 0;
                    margin-right: 0;
                    position: absolute;
                    padding: 20px 22px;
                    background: linear-gradient(
                      270deg,
                      #ff7e5f,
                      #feb47b,
                      #7bb4fe,
                      #fe7bb4
                    );
                    background-size: 400% 400%;
                    animation: gradient-animation 3s ease infinite;
                    border: none;

                    @keyframes gradient-animation {
                      0% {
                        background-position: 0% 50%;
                      }
                      50% {
                        background-position: 100% 50%;
                      }
                      100% {
                        background-position: 0% 50%;
                      }
                    }
                    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Optional: Add a shadow effect */
                  `}
                >
                  {" "}
                  <MicBigIcon
                    onClick={() => {
                      setIsListening((prevState) => !prevState);
                      handleButtonChange(query);
                      setNote("");
                    }}
                  />
                </div>
              </div>
              <div style={{ padding: "20px", textAlign: "center" }}>
                {" "}
                <p
                  className={css`
                    @keyframes text-gradient-animation {
                      0% {
                        background-position: 0% 50%;
                      }
                      50% {
                        background-position: 100% 50%;
                      }
                      100% {
                        background-position: 0% 50%;
                      }
                    }
                    background: linear-gradient(
                      270deg,
                      #ff7e5f,
                      #feb47b,
                      #7bb4fe,
                      #fe7bb4
                    );
                    background-size: 400% 400%;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    animation: text-gradient-animation 3s infinite;
                    font-size: 22px;
                    text-align: center;
                    font-weight: bold;
                  `}
                >
                  <TranslatorDashboardTag>
                    {displayedText}
                  </TranslatorDashboardTag>
                </p>
                <p style={{ textAlign: "center" }}>{note}</p>
              </div>
            </>
          ) : !isOnDashboard ? (
            <>
              <div
                style={{
                  padding: "10px 0px ",
                  paddingBottom: "0px",
                }}
              >
                {" "}
                {/* <Tooltip
                  title={"click here to chat with Max AI"}
                  style={{
                    display: "flex",
                    gap: "5px",
                  }}
                > */}
                <Text
                  onClick={() => {
                    //setIsAI(true);
                    handleModalOpen();
                  }}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    // gap: "2px",
                    // justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                >
                  <MagicIcon />{" "}
                  <span
                    style={{
                      fontWeight: 600,
                    }}
                  >
                    <TranslatorDashboardTag>MAX AI</TranslatorDashboardTag>
                  </span>
                </Text>{" "}
                {/* <MessageTextIcon size="small" /> */}
                {/* </Tooltip> */}
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
        {!isOnDashboard &&
          focusIndex !== -1 &&
          results &&
          results?.length > 0 &&
          query && (
            <div
              className={css`
                width: 40%;
                border-left: 1px solid rgba(51, 22, 0, 0.14);
                border-bottom-left-radius: 0px !important;
                border-top-left-radius: 0px !important;
                border-radius: 8px;
              `}
            >
              {results &&
                results?.length > 0 &&
                results?.map((item, index) => {
                  if (focusIndex === index) {
                    if (item?.link) {
                      return (
                        <div
                          className={css`
                            padding: 15px;
                            display: flex;
                            flex-direction: column;
                            gap: 8px;
                          `}
                        >
                          <div style={{ display: "flex", gap: "8px" }}>
                            {item?.link === "/admin/employees" ? (
                              <SearchUserIconIcon />
                            ) : item?.link === "/admin/teams" ? (
                              <DepartmentSearchIcon />
                            ) : item?.link === "/admin/payroll" ? (
                              <PayrollSearchIcon />
                            ) : item?.link &&
                              item?.link.length > 0 &&
                              item?.link.includes("report") ? (
                              <FileDocIcon />
                            ) : (
                              <></>
                            )}

                            <Text
                              style={{
                                color: "#F16444",
                                fontWeight: "bold",
                                fontSize: "16px",
                                textTransform: "capitalize",
                                // marginTop: "10px",
                              }}
                            >
                              {item?.title}
                            </Text>
                          </div>
                          {item?.description && (
                            <div
                              className={css`
                                background: rgb(150, 150, 150, 0.3);
                                padding: 8px;
                                margin-top: 20px;
                              `}
                            >
                              <div
                                className={css`
                                  display: flex;
                                `}
                              >
                                {" "}
                                <img
                                  src="/pics/Idea.png"
                                  style={{ height: "20px" }}
                                />{" "}
                                <p
                                  style={{
                                    color: "#F16444",
                                    marginLeft: "5px",
                                    lineHeight: "16px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  <TranslatorDashboardTag>
                                    MAX TIP
                                  </TranslatorDashboardTag>
                                </p>
                              </div>
                              <Text
                                style={{
                                  fontSize: "12px",
                                  color: "rgba(154, 142, 164, 1)",
                                  marginTop: "5px",
                                  // lineHeight: "12px",
                                }}
                              >
                                {item?.description}
                              </Text>
                            </div>
                          )}
                        </div>
                      );
                    } else {
                      const colorIndex = index % colorCodes.length;
                      const employeeColor = colorCodes[colorIndex];

                      const textColorIndex = index % textColorCodes.length;
                      const employeeTextColor = textColorCodes[textColorIndex];
                      return (
                        <div
                          className={css`
                            padding: 15px;
                          `}
                        >
                          <Avatar
                            size={32}
                            style={{
                              fontSize: 16,
                              background: employeeColor,
                            }}
                            icon={
                              item?.profileImage?.url === "dummy" ? (
                                <span
                                  style={{
                                    textTransform: "uppercase",
                                    color: employeeTextColor,
                                    fontSize: "12px",
                                  }}
                                >
                                  {item?.name?.firstName[0] +
                                    item?.name?.lastName[0]}
                                </span>
                              ) : (
                                <img alt="" src={item?.profileImage?.url} />
                              )
                            }
                          />

                          <Text
                            style={{
                              color: "#F16444",
                              fontWeight: "bold",
                              fontSize: "16px",
                              textTransform: "capitalize",
                              // marginTop: "10px",
                            }}
                          >
                            {item?.empId} - {item?.name?.firstName}{" "}
                            {item?.name?.lastName}
                          </Text>
                          <div
                            className={css`
                              background: #f7f6f5;
                              padding: 8px;
                              margin-top: 20px;
                            `}
                          >
                            <div
                              className={css`
                                display: flex;
                              `}
                            >
                              {" "}
                              <img
                                src="/pics/Idea.png"
                                style={{ height: "20px" }}
                              />{" "}
                              <p
                                style={{
                                  color: "#F16444",
                                  marginLeft: "5px",
                                  fontWeight: "bold",
                                }}
                              >
                                <TranslatorDashboardTag>
                                  MAX TIP
                                </TranslatorDashboardTag>
                              </p>
                            </div>
                            <p
                              style={{
                                fontSize: "12px",
                                color: "rgba(154, 142, 164, 1)",
                                marginTop: "5px",
                                lineHeight: "20px",
                              }}
                            >
                              <TranslatorDashboardTag>
                                Effortlessly manage user profiles with our
                                streamlined interface, ensuring seamless control
                                and accessibility.
                              </TranslatorDashboardTag>
                            </p>
                          </div>
                        </div>
                      );
                    }
                  }
                })}
            </div>
          )}
      </div>
    </>
  );
};

export default SearchBar;
